export default { NonSingletonsHash:
   'd5808572fd86f6098d5c38ead8947dd65da3df8546fcd4dd2f5c27b2e4cfccb5',
  SingletonsHash:
   'f19d9cc41f956435158386b6d9b9419358214bf9bf21bef92dde2e6f8c4e8746',
  Call:
   { abi:
      [ { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: '_method', type: 'bytes' } ],
          name: 'params0',
          outputs: [ { name: 'answer', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: '_method', type: 'bytes' },
             { name: '_val', type: 'uint256' } ],
          name: 'params1',
          outputs: [ { name: 'answer', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: '_method', type: 'bytes' },
             { name: '_val1', type: 'uint256' },
             { name: '_val2', type: 'uint256' } ],
          name: 'params2',
          outputs: [ { name: 'answer', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'sig', type: 'bytes' },
             { name: 'idx', type: 'uint256' } ],
          name: 'loadAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'sig', type: 'bytes' },
             { name: 'idx', type: 'uint256' } ],
          name: 'loadUint8',
          outputs: [ { name: '', type: 'uint8' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'hash', type: 'bytes32' },
             { name: 'sig', type: 'bytes' },
             { name: 'idx', type: 'uint256' } ],
          name: 'recoverHash',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'sig', type: 'bytes' },
             { name: 'old_key', type: 'address' },
             { name: 'last_address', type: 'address' } ],
          name: 'recoverSig',
          outputs:
           [ { name: '', type: 'address[]' },
             { name: '', type: 'address[]' },
             { name: '', type: 'uint8[]' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' } ],
     name: 'Call',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xeefce35a5f748ab47d574214897b90d5d09f6047',
           transactionHash:
            '0x379c621758eb77088d10757da26558de8582e8f888311632dcd3329ee9c41d04' },
        '180':
         { events: {},
           links: {},
           address: '0xa4da7bda81aba94c0e555c3b6c36d733987e3226',
           transactionHash:
            '0xc7725e3c02a0a5d9b882a1a6d45aee513634399ef28e68cfdfbe987cdd43205a' } } },
  IncentiveModels:
   { abi: [],
     name: 'IncentiveModels',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xd77fc82fc4c893b78891b0d0406a9bf9e648b1ff',
           transactionHash:
            '0x817344eb9d478e7a5c78200be85967de62a2320a90cb297ed1721a31005663ef' },
        '180':
         { events: {},
           links: {},
           address: '0x2d9736f06006c0e3176626a89b6b0717e796e2a4',
           transactionHash:
            '0x9b9a2b589db8a4c9ba65b4020f829d12fb1843fa56fe3492f320571abd58eaf4' } } },
  MockChainLinkOracle:
   { abi:
      [ { inputs:
           [ { name: 'decimals_', type: 'uint8' },
             { name: 'description_', type: 'string' },
             { name: 'version_', type: 'uint256' },
             { name: 'oraclesManager_', type: 'address' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'constructor' },
        { constant: true,
          inputs: [],
          name: 'oraclesManager',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'decimals',
          outputs: [ { name: '', type: 'uint8' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'description',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'version',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'latestRoundData',
          outputs:
           [ { name: 'roundId', type: 'uint80' },
             { name: 'answer', type: 'int256' },
             { name: 'startedAt', type: 'uint256' },
             { name: 'updatedAt', type: 'uint256' },
             { name: 'answeredInRound', type: 'uint80' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'newRateInDecimals', type: 'int256' } ],
          name: 'updatePrice',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'MockChainLinkOracle',
     bytecode:
      '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' },
  MockOraclesManager:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '', type: 'bytes32' } ],
          name: 'pairToOracleAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs: [ { name: '_twoKeySingletonRegistry', type: 'address' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'constructor' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'oracleAddress', type: 'address' },
             { indexed: false, name: 'oracleDescription', type: 'string' } ],
          name: 'OracleDeployed',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'oracleAddress', type: 'address' },
             { indexed: false, name: 'pair', type: 'bytes32' },
             { indexed: false, name: 'timestamp', type: 'uint256' },
             { indexed: false, name: 'rate', type: 'uint256' } ],
          name: 'PriceUpdated',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: 'currenciesPairs', type: 'bytes32[]' },
             { name: 'rates', type: 'uint256[]' } ],
          name: 'updateRates',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'decimals', type: 'uint8' },
             { name: 'oraclesDescription', type: 'bytes32[]' },
             { name: 'version', type: 'uint256' } ],
          name: 'deployAndStoreOracles',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_bytes32', type: 'bytes32' } ],
          name: 'bytes32ToStr',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getDeployedOraclesAndDescriptions',
          outputs:
           [ { name: '', type: 'address[]' },
             { name: '', type: 'bytes32[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'MockOraclesManager',
     bytecode:
      '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' },
  StandardTokenModified:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'name',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'decimals',
          outputs: [ { name: '', type: 'uint8' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'symbol',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'transfersFrozen',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: true, name: 'from', type: 'address' },
             { indexed: true, name: 'to', type: 'address' },
             { indexed: false, name: 'value', type: 'uint256' } ],
          name: 'Transfer',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: true, name: 'tokenOwner', type: 'address' },
             { indexed: true, name: 'spender', type: 'address' },
             { indexed: false, name: 'tokens', type: 'uint256' } ],
          name: 'Approval',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_from', type: 'address' },
             { name: '_to', type: 'address' },
             { name: '_value', type: 'uint256' } ],
          name: 'transferFrom',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_spender', type: 'address' },
             { name: '_value', type: 'uint256' } ],
          name: 'approve',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_owner', type: 'address' },
             { name: '_spender', type: 'address' } ],
          name: 'allowance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_spender', type: 'address' },
             { name: '_addedValue', type: 'uint256' } ],
          name: 'increaseApproval',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_spender', type: 'address' },
             { name: '_subtractedValue', type: 'uint256' } ],
          name: 'decreaseApproval',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'totalSupply',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_to', type: 'address' },
             { name: '_value', type: 'uint256' } ],
          name: 'transfer',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_owner', type: 'address' } ],
          name: 'balanceOf',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'StandardTokenModified',
     networks: {} },
  TwoKeyAdmin:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { payable: true, stateMutability: 'payable', type: 'fallback' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorageContract', type: 'address' },
             { name: '_twoKeyTokenReleaseDate', type: 'uint256' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'to', type: 'address' },
             { name: 'amount', type: 'uint256' } ],
          name: 'transferEtherByAdmins',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_coreDevs', type: 'address[]' } ],
          name: 'addCoreDevsToMaintainerRegistry',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_maintainers', type: 'address[]' } ],
          name: 'addMaintainersToMaintainersRegistry',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_coreDevs', type: 'address[]' } ],
          name: 'removeCoreDevsFromMaintainersRegistry',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_maintainers', type: 'address[]' } ],
          name: 'removeMaintainersFromMaintainersRegistry',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'freezeTransfersInEconomy',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'unfreezeTransfersInEconomy',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_to', type: 'address' },
             { name: '_amount', type: 'uint256' } ],
          name: 'transfer2KeyTokens',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'currency', type: 'string' },
             { name: 'amount', type: 'uint256' } ],
          name: 'addFeesCollectedInCurrency',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_amountOfTokens', type: 'uint256' } ],
          name: 'withdrawDAIAvailableToFillReserveFromUpgradableExchange',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'beneficiary', type: 'address' },
             { name: 'amountToBeWithdrawn', type: 'uint256' } ],
          name: 'withdrawModeratorEarningsFromAdmin',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'beneficiary', type: 'address' },
             { name: 'currency', type: 'string' },
             { name: 'amountToBeWithdrawn', type: 'uint256' } ],
          name: 'withdrawFeeManagerEarningsFromAdmin',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'beneficiary', type: 'address' },
             { name: 'amountToBeWithdrawn', type: 'uint256' } ],
          name: 'withdrawKyberFeesEarningsFromAdmin',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'beneficiary', type: 'address' },
             { name: 'amountToBeWithdrawn', type: 'uint256' } ],
          name: 'withdrawUpgradableExchangeDaiCollectedFromAdmin',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'beneficiary', type: 'address' },
             { name: 'amountToWithdraw', type: 'uint256' } ],
          name: 'withdrawFeesCollectedFromDistributionRewards',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'amountOfTokens', type: 'uint256' },
             { name: 'campaignPlasma', type: 'address' } ],
          name: 'updateReceivedTokensAsModeratorPPC',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfTokens', type: 'uint256' } ],
          name: 'updateTokensReceivedFromDistributionFees',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfTokens', type: 'uint256' } ],
          name: 'updateReceivedTokensAsModerator',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_campaignAddress', type: 'address' } ],
          name: 'getModeratorEarningsPerCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getTwoKeyRewardsReleaseDate',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getDefaultIntegratorFeePercent',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getDefaultNetworkTaxPercent',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'newFeePercent', type: 'uint256' } ],
          name: 'setDefaultIntegratorFeePercent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAmountOfTokensReceivedAsModerator',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAmountOfTokensReceivedFromDistributionFees',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAmountOfTokensWithdrawnFromDistributionFees',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAccountingReport',
          outputs: [ { name: '', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyAdmin',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x7b7f205679ae0419ccaa36ea2def09cfc2497c8d',
           transactionHash:
            '0xb54c052e11a0e298457880844b93883f1b976437b50fd2cd823c1e0daae0b969',
           implementationAddressLogic: '0x7b7f205679ae0419ccaa36ea2def09cfc2497c8d',
           Proxy: '0x31cf9c7847c979313fe27eadfcc847a8a0252d86',
           implementationAddressStorage: '0x2ad9a1347e224a243bb03e3f9fd4f9dade0db71d',
           StorageProxy: '0xbada2b40f206728f5475dac7c2edfad05e6cd99d' } } },
  TwoKeyBaseReputationRegistry:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_plasmaAddress', type: 'address' },
             { indexed: false, name: '_role', type: 'string' },
             { indexed: false, name: '_type', type: 'string' },
             { indexed: false, name: '_points', type: 'int256' },
             { indexed: false, name: '_campaignAddress', type: 'address' } ],
          name: 'ReputationUpdated',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletoneRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'converter', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'campaign', type: 'address' } ],
          name: 'updateOnConversionExecutedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'converter', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'campaign', type: 'address' } ],
          name: 'updateOnConversionRejectedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getReputationForUser',
          outputs:
           [ { name: '', type: 'int256' }, { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getGlobalReputationForUser',
          outputs: [ { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'plasmaAddresses', type: 'address[]' } ],
          name: 'getGlobalReputationForUsers',
          outputs: [ { name: '', type: 'int256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getReputationForContractor',
          outputs: [ { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'plasmaAddresses', type: 'address[]' } ],
          name: 'getGlobalReputationForContractors',
          outputs: [ { name: '', type: 'int256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyBaseReputationRegistry',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xd6966cc15f3e86947cd920558676c31fc2e67fa1',
           transactionHash:
            '0xef246d1c0eeacc9a05c09ac624c4a20e6d59f2a12a2590d74277b92fa603749d',
           implementationAddressLogic: '0xd6966cc15f3e86947cd920558676c31fc2e67fa1',
           Proxy: '0x17409d8df3866264b76465292a9dee3354d4bde6',
           implementationAddressStorage: '0x2061341cb7e53450ca3e998398f2944c99b27547',
           StorageProxy: '0x2e110ce00850f6eca041ee9cc88625ae870291fb' } } },
  TwoKeyBudgetCampaignsPaymentsHandler:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorageContract', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignPlasma', type: 'address' },
             { name: 'amountOf2KEYTokens', type: 'uint256' },
             { name: 'bountyPerConversionFiat', type: 'uint256' } ],
          name: 'addInventory2KEY',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignPlasma', type: 'address' },
             { name: 'amountOfStableCoins', type: 'uint256' },
             { name: 'bountyPerConversionFiat', type: 'uint256' },
             { name: 'tokenAddress', type: 'address' } ],
          name: 'addInventory',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'campaignPlasmaAddress', type: 'address' } ],
          name: 'withdrawLeftoverForContractor',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignPlasma', type: 'address' },
             { name: 'totalAmountForReferrerRewards', type: 'uint256' },
             { name: 'totalAmountForModeratorRewards', type: 'uint256' } ],
          name: 'endCampaignReserveTokensAndRebalanceRates',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'influencers', type: 'address[]' },
             { name: 'balances', type: 'uint256[]' },
             { name: 'nonRebalancedTotalPayout', type: 'uint256' },
             { name: 'rebalancedTotalPayout', type: 'uint256' },
             { name: 'cycleId', type: 'uint256' },
             { name: 'feePerReferrerIn2KEY', type: 'uint256' } ],
          name: 'pushAndDistributeRewardsBetweenInfluencers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getRebalancingRatioForCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfCycles',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getInitialBountyForCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getInitial2KEYRateForCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'cycleId', type: 'uint256' } ],
          name: 'getTotalDistributedInCycle',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignAddress', type: 'address' } ],
          name: 'getModeratorEarningsRebalancedForCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignAddress', type: 'address' } ],
          name: 'getContractorRebalancedLeftoverForCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignAddress', type: 'address' } ],
          name:
           'getModeratorEarningsAndContractorLeftoverRebalancedForCampaign',
          outputs:
           [ { name: '', type: 'uint256' }, { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getIfLeftoverForCampaignIsWithdrawn',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getNonRebalancedReferrerRewards',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'stableCoinsAddresses', type: 'address[]' } ],
          name: 'getBalanceOfStableCoinsOnContract',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getAmountOfStableCoinsUsedToFundCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getBountyPerConversion2KEY',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getIsCampaignBudgetedDirectlyWith2KEY',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getStableCoinAddressUsedToFundCampaign',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getCampaignSummary',
          outputs: [ { name: '', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignPlasma', type: 'address' } ],
          name: 'getInitialParamsForCampaign',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'bool' },
             { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignAddress', type: 'address' } ],
          name: 'getCampaignContractor',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'fiatCurrency', type: 'string' },
             { name: 'fiatBudgetAmount', type: 'uint256' } ],
          name: 'getRequiredBudget2KEY',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'cycleId', type: 'uint256' } ],
          name: 'getFeePerCycleIdPerReferrer',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyBudgetCampaignsPaymentsHandler',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x8c1bb3855710294c520f7094887ab504946da124',
           transactionHash:
            '0xe752a89c50c5e082cc9fd6692ca2aeb9b4dd3d5461b2c23c61f5352f3bf17aff',
           implementationAddressLogic: '0x8c1bb3855710294c520f7094887ab504946da124',
           Proxy: '0x80afff9bd23857ef0bc7fb0498b28638b57f80d2',
           implementationAddressStorage: '0x21bfc4c88257482f720c8b975621b1be3fef30a0',
           StorageProxy: '0x0631493864cDc718324331D07F93dfcf586f65a6' } } },
  TwoKeyCampaignValidator:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletoneRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaign', type: 'address' },
             { name: 'nonSingletonHash', type: 'string' } ],
          name: 'validateAcquisitionCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaign', type: 'address' },
             { name: 'donationConversionHandler', type: 'address' },
             { name: 'donationLogicHandler', type: 'address' },
             { name: 'nonSingletonHash', type: 'string' } ],
          name: 'validateDonationCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaign', type: 'address' },
             { name: 'nonSingletonHash', type: 'string' } ],
          name: 'validateCPCCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaign', type: 'address' } ],
          name: 'isCampaignValidated',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaign', type: 'address' } ],
          name: 'campaign2NonSingletonHash',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyCampaignValidator',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xaae9c5f1731922e9e6347377abe3349854f0ca75',
           transactionHash:
            '0x12d523839538e3a0beea3ba5c942102b8c101e8857472af9b433d000a400e819',
           implementationAddressLogic: '0xaae9c5f1731922e9e6347377abe3349854f0ca75',
           Proxy: '0x623eca42b9308dc38d5be9f38b844de56f2f7a57',
           implementationAddressStorage: '0x97d705e4234864b304457773f3cad90799c24a25',
           StorageProxy: '0x4c2be2d3a43bb03c5cdf051bed4b0fef4755e7e9' } } },
  TwoKeyCongress:
   { abi:
      [ { constant: true,
          inputs: [ { name: '', type: 'uint256' } ],
          name: 'proposals',
          outputs:
           [ { name: 'recipient', type: 'address' },
             { name: 'amount', type: 'uint256' },
             { name: 'description', type: 'string' },
             { name: 'minExecutionDate', type: 'uint256' },
             { name: 'executed', type: 'bool' },
             { name: 'proposalPassed', type: 'bool' },
             { name: 'numberOfVotes', type: 'uint256' },
             { name: 'againstProposalTotal', type: 'uint256' },
             { name: 'supportingProposalTotal', type: 'uint256' },
             { name: 'proposalHash', type: 'bytes32' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'numProposals',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'debatingPeriodInMinutes',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'twoKeyCongressMembersRegistry',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs: [ { name: '_minutesForDebate', type: 'uint256' } ],
          payable: true,
          stateMutability: 'payable',
          type: 'constructor' },
        { payable: true, stateMutability: 'payable', type: 'fallback' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'sender', type: 'address' },
             { indexed: false, name: 'amount', type: 'uint256' } ],
          name: 'ReceivedEther',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proposalID', type: 'uint256' },
             { indexed: false, name: 'recipient', type: 'address' },
             { indexed: false, name: 'amount', type: 'uint256' },
             { indexed: false, name: 'description', type: 'string' } ],
          name: 'ProposalAdded',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proposalID', type: 'uint256' },
             { indexed: false, name: 'position', type: 'bool' },
             { indexed: false, name: 'voter', type: 'address' },
             { indexed: false, name: 'justification', type: 'string' } ],
          name: 'Voted',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proposalID', type: 'uint256' },
             { indexed: false, name: 'quorum', type: 'uint256' },
             { indexed: false, name: 'active', type: 'bool' } ],
          name: 'ProposalTallied',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: '_newDebatingPeriodInMinutes',
               type: 'uint256' } ],
          name: 'ChangeOfRules',
          type: 'event' },
        { constant: false,
          inputs: [ { name: '_twoKeyCongressMembers', type: 'address' } ],
          name: 'setTwoKeyCongressMembersContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'beneficiary', type: 'address' },
             { name: 'weiAmount', type: 'uint256' },
             { name: 'jobDescription', type: 'string' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          name: 'newProposal',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'proposalNumber', type: 'uint256' },
             { name: 'beneficiary', type: 'address' },
             { name: 'weiAmount', type: 'uint256' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          name: 'checkProposalCode',
          outputs: [ { name: 'codeChecksOut', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proposalNumber', type: 'uint256' },
             { name: 'supportsProposal', type: 'bool' },
             { name: 'justificationText', type: 'string' } ],
          name: 'vote',
          outputs: [ { name: 'voteID', type: 'uint256' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'proposalNumber', type: 'uint256' } ],
          name: 'getVoteCount',
          outputs:
           [ { name: 'numberOfVotes', type: 'uint256' },
             { name: 'supportingProposalTotal', type: 'uint256' },
             { name: 'againstProposalTotal', type: 'uint256' },
             { name: 'description', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proposalNumber', type: 'uint256' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          name: 'executeProposal',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'proposalId', type: 'uint256' } ],
          name: 'getProposalData',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'string' },
             { name: '', type: 'uint256' },
             { name: '', type: 'bool' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyCongress',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x210d093bb95d6bebad37954f76c8a57ea54b9914',
           transactionHash:
            '0xf618679649853fa4e0a5db185c3d7b1e2b3dd230ce1e822829c2fc6fe9b3a29a' } } },
  TwoKeyCongressMembersRegistry:
   { abi:
      [ { constant: true,
          inputs: [ { name: '', type: 'address' } ],
          name: 'isMemberInCongress',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'minimumQuorum',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '', type: 'address' } ],
          name: 'address2Member',
          outputs:
           [ { name: 'memberAddress', type: 'address' },
             { name: 'name', type: 'bytes32' },
             { name: 'votingPower', type: 'uint256' },
             { name: 'memberSince', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_CONGRESS',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'maxVotingPower',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '', type: 'uint256' } ],
          name: 'allMembers',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs:
           [ { name: 'initialCongressMembers', type: 'address[]' },
             { name: 'initialCongressMemberNames', type: 'bytes32[]' },
             { name: 'memberVotingPowers', type: 'uint256[]' },
             { name: '_twoKeyCongress', type: 'address' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'constructor' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'member', type: 'address' },
             { indexed: false, name: 'isMember', type: 'bool' } ],
          name: 'MembershipChanged',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: 'targetMember', type: 'address' },
             { name: 'memberName', type: 'bytes32' },
             { name: '_votingPower', type: 'uint256' } ],
          name: 'addMember',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'targetMember', type: 'address' } ],
          name: 'removeMember',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_memberAddress', type: 'address' } ],
          name: 'getMemberVotingPower',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_address', type: 'address' } ],
          name: 'isMember',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getMembersLength',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAllMemberAddresses',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getMemberInfo',
          outputs:
           [ { name: '', type: 'address' },
             { name: '', type: 'bytes32' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyCongressMembersRegistry',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x4c18afbf062c9064300b3ce469bf0035fe0ca6c6',
           transactionHash:
            '0x7e105cf7f7dca388df809c42a5188220e1ee9e21c3cca4fec630d10fa69aa878' } } },
  TwoKeyDeepFreezeTokenPool:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'twoKeyParticipationMiningPool',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getContractBalance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonesRegistry', type: 'address' },
             { name: '_twoKeyParticipationMiningPool', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amount', type: 'uint256' } ],
          name: 'transferTokensToCommunityPool',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'amountOfTokens', type: 'uint256' },
             { name: 'campaignAddress', type: 'address' } ],
          name: 'updateReceivedTokensForSuccessfulConversions',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyDeepFreezeTokenPool',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xc4a300ffb8b0496d0335a3487fa6910a14913846',
           transactionHash:
            '0xf40cb592db1dce00e5fb331a4159c8a6d5fdd1810e48df54b4a5828bff289a83',
           implementationAddressLogic: '0xc4a300ffb8b0496d0335a3487fa6910a14913846',
           Proxy: '0xc64852cebd68256d0517f4ce41ac1e9773c8a265',
           implementationAddressStorage: '0xe26597eed657533aede5e195a8f248f3af95817b',
           StorageProxy: '0x9b7562c02b2105cb32a1142535c58ff39225705d' } } },
  TwoKeyEconomy:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'name',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_spender', type: 'address' },
             { name: '_value', type: 'uint256' } ],
          name: 'approve',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'twoKeyAdmin',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'totalSupply',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_from', type: 'address' },
             { name: '_to', type: 'address' },
             { name: '_value', type: 'uint256' } ],
          name: 'transferFrom',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'decimals',
          outputs: [ { name: '', type: 'uint8' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_spender', type: 'address' },
             { name: '_subtractedValue', type: 'uint256' } ],
          name: 'decreaseApproval',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_owner', type: 'address' } ],
          name: 'balanceOf',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'symbol',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_to', type: 'address' },
             { name: '_value', type: 'uint256' } ],
          name: 'transfer',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_spender', type: 'address' },
             { name: '_addedValue', type: 'uint256' } ],
          name: 'increaseApproval',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_owner', type: 'address' },
             { name: '_spender', type: 'address' } ],
          name: 'allowance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'transfersFrozen',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'twoKeySingletonRegistry',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs: [ { name: '_twoKeySingletonRegistry', type: 'address' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'constructor' },
        { anonymous: false,
          inputs:
           [ { indexed: true, name: 'from', type: 'address' },
             { indexed: true, name: 'to', type: 'address' },
             { indexed: false, name: 'value', type: 'uint256' } ],
          name: 'Transfer',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: true, name: 'tokenOwner', type: 'address' },
             { indexed: true, name: 'spender', type: 'address' },
             { indexed: false, name: 'tokens', type: 'uint256' } ],
          name: 'Approval',
          type: 'event' },
        { constant: false,
          inputs: [],
          name: 'freezeTransfers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'unfreezeTransfers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyEconomy',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xe48972fcd82a274411c01834e2f031d4377fa2c0',
           transactionHash:
            '0xcb6c9c2e72538562b8d5685a238977f1c1652ebf9789bc5b4e9d2ce49bb6f5e9' } } },
  TwoKeyEventSource:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_owner', type: 'address' },
             { indexed: false, name: '_moderator', type: 'address' } ],
          name: 'Created',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_from', type: 'address' },
             { indexed: false, name: '_to', type: 'address' } ],
          name: 'Joined',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_converter', type: 'address' },
             { indexed: false, name: '_amount', type: 'uint256' } ],
          name: 'Converted',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_converterPlasma', type: 'address' },
             { indexed: false, name: '_baseTokens', type: 'uint256' },
             { indexed: false, name: '_bonusTokens', type: 'uint256' },
             { indexed: false, name: '_conversionAmount', type: 'uint256' },
             { indexed: false, name: '_isFiatConversion', type: 'bool' },
             { indexed: false, name: '_conversionId', type: 'uint256' } ],
          name: 'ConvertedAcquisition',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_converterPlasma', type: 'address' },
             { indexed: false, name: '_conversionAmount', type: 'uint256' },
             { indexed: false, name: '_conversionId', type: 'uint256' } ],
          name: 'ConvertedDonation',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_to', type: 'address' },
             { indexed: false, name: '_amount', type: 'uint256' } ],
          name: 'Rewarded',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_converter', type: 'address' },
             { indexed: false, name: '_indexOrAmount', type: 'uint256' } ],
          name: 'Cancelled',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_campaign', type: 'address' },
             { indexed: false, name: '_converter', type: 'address' } ],
          name: 'Rejected',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'timestamp', type: 'uint256' },
             { indexed: false, name: 'value', type: 'string' } ],
          name: 'UpdatedPublicMetaHash',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'timestamp', type: 'uint256' },
             { indexed: false, name: 'value', type: 'uint256' },
             { indexed: false, name: 'action', type: 'string' } ],
          name: 'UpdatedData',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_sender', type: 'address' },
             { indexed: false, name: 'value', type: 'uint256' } ],
          name: 'ReceivedEther',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proxyLogicHandler', type: 'address' },
             { indexed: false,
               name: 'proxyConversionHandler',
               type: 'address' },
             { indexed: false,
               name: 'proxyAcquisitionCampaign',
               type: 'address' },
             { indexed: false,
               name: 'proxyPurchasesHandler',
               type: 'address' },
             { indexed: false, name: 'contractor', type: 'address' } ],
          name: 'AcquisitionCampaignCreated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'proxyDonationCampaign',
               type: 'address' },
             { indexed: false,
               name: 'proxyDonationConversionHandler',
               type: 'address' },
             { indexed: false,
               name: 'proxyDonationLogicHandler',
               type: 'address' },
             { indexed: false, name: 'contractor', type: 'address' } ],
          name: 'DonationCampaignCreated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proxyCPCCampaign', type: 'address' },
             { indexed: false, name: 'contractor', type: 'address' } ],
          name: 'CPCCampaignCreated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_currency', type: 'bytes32' },
             { indexed: false, name: 'newRate', type: 'uint256' },
             { indexed: false, name: '_timestamp', type: 'uint256' },
             { indexed: false, name: '_updater', type: 'address' } ],
          name: 'PriceUpdated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_handle', type: 'string' },
             { indexed: false, name: '_address', type: 'address' } ],
          name: 'UserRegistered',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'campaignAddress', type: 'address' },
             { indexed: false,
               name: 'converterPlasmaAddress',
               type: 'address' },
             { indexed: false, name: 'conversionId', type: 'uint256' },
             { indexed: false, name: 'tokens', type: 'uint256' } ],
          name: 'Executed',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'campaignAddress', type: 'address' },
             { indexed: false, name: 'conversionID', type: 'uint256' },
             { indexed: false,
               name: 'tokensAmountWithdrawn',
               type: 'uint256' } ],
          name: 'TokenWithdrawnFromPurchasesHandler',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'plasmaAddress', type: 'address' },
             { indexed: false, name: 'weiAmount', type: 'uint256' },
             { indexed: false, name: 'addition', type: 'bool' },
             { indexed: false, name: 'currency', type: 'string' } ],
          name: 'Debt',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'campaignAddress', type: 'address' },
             { indexed: false, name: 'amountOfTokens', type: 'uint256' } ],
          name: 'ReceivedTokensAsModerator',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'campaignAddress', type: 'address' },
             { indexed: false, name: 'amountOfTokens', type: 'uint256' } ],
          name: 'ReceivedTokensDeepFreezeTokenPool',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'userPlasmaAddress', type: 'address' },
             { indexed: false, name: 'newHandle', type: 'string' } ],
          name: 'HandleChanged',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'contractSenderAddress',
               type: 'address' },
             { indexed: false, name: 'amountOfDAI', type: 'uint256' } ],
          name: 'DaiReleased',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'priceAtBeginning', type: 'uint256' },
             { indexed: false,
               name: 'priceAtRebalancingTime',
               type: 'uint256' },
             { indexed: false, name: 'ratio', type: 'uint256' },
             { indexed: false,
               name: 'amountOfTokensTransferedInAction',
               type: 'uint256' },
             { indexed: false,
               name: 'actionPerformedWithUpgradableExchange',
               type: 'string' } ],
          name: 'RebalancedRatesEvent',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'campaignPlasmaAddress',
               type: 'address' },
             { indexed: false, name: 'contractorLeftover', type: 'uint256' },
             { indexed: false,
               name: 'moderatorEarningsDistributed',
               type: 'uint256' } ],
          name: 'EndedBudgetCampaign',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'cycleId', type: 'uint256' },
             { indexed: false, name: 'amountOfTokens', type: 'uint256' },
             { indexed: false, name: 'action', type: 'string' } ],
          name: 'RebalancedRewards',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'user', type: 'address' },
             { indexed: false, name: 'amountOfTokens', type: 'uint256' } ],
          name: 'UserWithdrawnNetworkEarnings',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonesRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_owner', type: 'address' },
             { name: '_moderator', type: 'address' } ],
          name: 'created',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_from', type: 'address' },
             { name: '_to', type: 'address' } ],
          name: 'joined',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_converter', type: 'address' },
             { name: '_conversionAmount', type: 'uint256' } ],
          name: 'converted',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_converter', type: 'address' } ],
          name: 'rejected',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaignAddress', type: 'address' },
             { name: '_converterPlasmaAddress', type: 'address' },
             { name: '_conversionId', type: 'uint256' },
             { name: 'tokens', type: 'uint256' } ],
          name: 'executed',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_converterPlasma', type: 'address' },
             { name: '_baseTokens', type: 'uint256' },
             { name: '_bonusTokens', type: 'uint256' },
             { name: '_conversionAmount', type: 'uint256' },
             { name: '_isFiatConversion', type: 'bool' },
             { name: '_conversionId', type: 'uint256' } ],
          name: 'convertedAcquisition',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_converterPlasma', type: 'address' },
             { name: '_conversionAmount', type: 'uint256' },
             { name: '_conversionId', type: 'uint256' } ],
          name: 'convertedDonation',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_to', type: 'address' },
             { name: '_amount', type: 'uint256' } ],
          name: 'rewarded',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaign', type: 'address' },
             { name: '_converter', type: 'address' },
             { name: '_indexOrAmount', type: 'uint256' } ],
          name: 'cancelled',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proxyLogicHandler', type: 'address' },
             { name: 'proxyConversionHandler', type: 'address' },
             { name: 'proxyAcquisitionCampaign', type: 'address' },
             { name: 'proxyPurchasesHandler', type: 'address' },
             { name: 'contractor', type: 'address' } ],
          name: 'acquisitionCampaignCreated',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proxyDonationCampaign', type: 'address' },
             { name: 'proxyDonationConversionHandler', type: 'address' },
             { name: 'proxyDonationLogicHandler', type: 'address' },
             { name: 'contractor', type: 'address' } ],
          name: 'donationCampaignCreated',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proxyCPC', type: 'address' },
             { name: 'contractor', type: 'address' } ],
          name: 'cpcCampaignCreated',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_currency', type: 'bytes32' },
             { name: '_newRate', type: 'uint256' },
             { name: '_timestamp', type: 'uint256' },
             { name: '_updater', type: 'address' } ],
          name: 'priceUpdated',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_handle', type: 'string' },
             { name: '_address', type: 'address' },
             { name: '_registrationFee', type: 'uint256' } ],
          name: 'userRegistered',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_debtAmount', type: 'uint256' },
             { name: '_debtType', type: 'string' } ],
          name: 'addAdditionalDebtForUser',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_amount', type: 'uint256' },
             { name: '_isAddition', type: 'bool' },
             { name: '_currency', type: 'string' } ],
          name: 'emitDebtEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaignAddress', type: 'address' },
             { name: '_amountOfTokens', type: 'uint256' } ],
          name: 'emitReceivedTokensAsModerator',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaignAddress', type: 'address' },
             { name: '_amountOfTokens', type: 'uint256' } ],
          name: 'emitReceivedTokensToDeepFreezeTokenPool',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaignAddress', type: 'address' },
             { name: '_conversionID', type: 'uint256' },
             { name: '_tokensAmountWithdrawn', type: 'uint256' } ],
          name: 'tokensWithdrawnFromPurchasesHandler',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'priceAtBeginning', type: 'uint256' },
             { name: 'priceAtRebalancingTime', type: 'uint256' },
             { name: 'ratio', type: 'uint256' },
             { name: 'amountOfTokensTransferedInAction', type: 'uint256' },
             { name: 'actionPerformedWithUpgradableExchange',
               type: 'string' } ],
          name: 'emitRebalancedRatesEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_userPlasmaAddress', type: 'address' },
             { name: '_newHandle', type: 'string' } ],
          name: 'emitHandleChangedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_campaignContractAddress', type: 'address' },
             { name: '_amountOfDAI', type: 'uint256' } ],
          name: 'emitDAIReleasedAsIncome',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignPlasmaAddress', type: 'address' },
             { name: 'contractorLeftover', type: 'uint256' },
             { name: 'moderatorEarningsDistributed', type: 'uint256' } ],
          name: 'emitEndedBudgetCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'cycleId', type: 'uint256' },
             { name: 'difference', type: 'uint256' },
             { name: 'action', type: 'string' } ],
          name: 'emitRebalancedRewards',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'user', type: 'address' },
             { name: 'amountOfTokens', type: 'uint256' } ],
          name: 'emitUserWithdrawnNetworkEarnings',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'me', type: 'address' } ],
          name: 'plasmaOf',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'me', type: 'address' } ],
          name: 'ethereumOf',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_maintainer', type: 'address' } ],
          name: 'isAddressMaintainer',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getTwoKeyDefaultIntegratorFeeFromAdmin',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getTwoKeyDefaultNetworkTaxPercent',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyEventSource',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xe78174b6f058c23dce46249e18968facbdf6eabe',
           transactionHash:
            '0x916a54bd65d63b27c25d8ce7eb4837761b31da98f597bd7b5a2afed2d41aa6d6',
           implementationAddressLogic: '0xe78174b6f058c23dce46249e18968facbdf6eabe',
           Proxy: '0xcf12c8227ce211fa791f03d30e3af9dddbba8019',
           implementationAddressStorage: '0xfe6b39e9e62d015e76ffc8b6870fcb8894a87afe',
           StorageProxy: '0x377cf47d928ec537dd25349849619118eaffc594' } } },
  TwoKeyExchangeRateContract:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonesRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_currency', type: 'bytes32' },
             { name: '_baseToTargetRate', type: 'uint256' } ],
          name: 'setFiatCurrencyDetails',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_currencies', type: 'bytes32[]' },
             { name: '_baseToTargetRates', type: 'uint256[]' } ],
          name: 'setMultipleFiatCurrencyDetails',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'hexedPairs', type: 'bytes32[]' },
             { name: 'priceFeeds', type: 'address[]' } ],
          name: 'storeChainLinkOracleAddresses',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'base_target', type: 'string' } ],
          name: 'getBaseToTargetRate',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'base_target', type: 'string' },
             { name: 'base_amount', type: 'uint256' } ],
          name: 'exchangeCurrencies',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'amountInFiatWei', type: 'uint256' },
             { name: 'fiatCurrency', type: 'string' },
             { name: 'stableCoinPairs', type: 'bytes32[]' } ],
          name: 'getFiatToStableQuotes',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'get2KeyDaiRate',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'stableCoinAddress', type: 'address' } ],
          name: 'getStableCoinToUSDQuota',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'oracleAddress', type: 'address' } ],
          name: 'getLatestPrice',
          outputs: [ { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'oracleAddress', type: 'address' } ],
          name: 'getDecimalsReturnPrecision',
          outputs: [ { name: '', type: 'uint8' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'pair', type: 'string' } ],
          name: 'getChainLinkOracleAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyExchangeRateContract',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xca275ea9921d9693ba0fe489ed9bb58955538dea',
           transactionHash:
            '0x1aec150e2078c9a3dc861962f4faad137e39cd958cea4e5c0e43eb74d8267f8e',
           implementationAddressLogic: '0xca275ea9921d9693ba0fe489ed9bb58955538dea',
           Proxy: '0x77887bee75eaec95b1f2889c069615b131e7dbc8',
           implementationAddressStorage: '0xf62ae1f14950dc1042c8683f8ed4b572927ca57c',
           StorageProxy: '0xb6a419897f58993e384c3e197fb75a22ca98e098' } } },
  TwoKeyFactory:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proxyLogicHandler', type: 'address' },
             { indexed: false,
               name: 'proxyConversionHandler',
               type: 'address' },
             { indexed: false,
               name: 'proxyAcquisitionCampaign',
               type: 'address' },
             { indexed: false,
               name: 'proxyPurchasesHandler',
               type: 'address' },
             { indexed: false, name: 'contractor', type: 'address' } ],
          name: 'ProxyForCampaign',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'proxyDonationCampaign',
               type: 'address' },
             { indexed: false,
               name: 'proxyDonationConversionHandler',
               type: 'address' },
             { indexed: false,
               name: 'proxyDonationLogicHandler',
               type: 'address' },
             { indexed: false, name: 'contractor', type: 'address' } ],
          name: 'ProxyForDonationCampaign',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignType', type: 'string' } ],
          name: 'getLatestApprovedCampaignVersion',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'addresses', type: 'address[]' },
             { name: 'valuesConversion', type: 'uint256[]' },
             { name: 'valuesLogicHandler', type: 'uint256[]' },
             { name: 'values', type: 'uint256[]' },
             { name: '_currency', type: 'string' },
             { name: '_nonSingletonHash', type: 'string' } ],
          name: 'createProxiesForAcquisitions',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_moderator', type: 'address' },
             { name: 'numberValues', type: 'uint256[]' },
             { name: 'booleanValues', type: 'bool[]' },
             { name: '_currency', type: 'string' },
             { name: 'tokenName', type: 'string' },
             { name: 'tokenSymbol', type: 'string' },
             { name: 'nonSingletonHash', type: 'string' } ],
          name: 'createProxiesForDonationCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_url', type: 'string' },
             { name: '_bountyPerConversion', type: 'uint256' },
             { name: '_mirrorCampaignOnPlasma', type: 'address' },
             { name: '_nonSingletonHash', type: 'string' } ],
          name: 'createProxyForCPCCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_key', type: 'address' } ],
          name: 'addressToCampaignType',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyFactory',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x9b450b14f19fd2106abdea24b94982663d9f14c6',
           transactionHash:
            '0x805a8deb6a167ffb235855d11ca33260460e47896be02e8d7c7beeff5a0850d3',
           implementationAddressLogic: '0x9b450b14f19fd2106abdea24b94982663d9f14c6',
           Proxy: '0xd8eab6642265d5a1ba1c7ab20d9ce2d26afd8d15',
           implementationAddressStorage: '0xa4da7bda81aba94c0e555c3b6c36d733987e3226',
           StorageProxy: '0xd23da67e6b63797e0a47489585af1ffae60dc0d6' } } },
  TwoKeyFeeManager:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_debtAmount', type: 'uint256' },
             { name: '_debtType', type: 'string' } ],
          name: 'addDebtForUser',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_registrationFee', type: 'uint256' } ],
          name: 'setRegistrationFeeForUser',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'isRegistrationDebtSubmittedForTheUser',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'usersPlasmas', type: 'address[]' },
             { name: 'fees', type: 'uint256[]' } ],
          name: 'setRegistrationFeesForUsers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_userPlasma', type: 'address' } ],
          name: 'getDebtForUser',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_debtPaying', type: 'uint256' } ],
          name: 'payDebtWhenConvertingOrWithdrawingProceeds',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_totalDebtDAI', type: 'uint256' },
             { name: '_debtAmountPaidDAI', type: 'uint256' } ],
          name: 'payDebtWithDAI',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_beneficiaryPublic', type: 'address' },
             { name: '_plasmaAddress', type: 'address' },
             { name: '_amountOf2keyForRewards', type: 'uint256' },
             { name: '_twoKeyEconomy', type: 'address' },
             { name: '_twoKeyAdmin', type: 'address' } ],
          name: 'payDebtWith2KeyV2',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_beneficiaryPublic', type: 'address' },
             { name: '_plasmaAddress', type: 'address' },
             { name: '_amountOf2keyForRewards', type: 'uint256' },
             { name: '_twoKeyEconomy', type: 'address' } ],
          name: 'payDebtWith2KeyV2',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_beneficiaryPublic', type: 'address' },
             { name: '_plasmaAddress', type: 'address' },
             { name: '_amountOf2keyForRewards', type: 'uint256' } ],
          name: 'payDebtWith2Key',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignAddress', type: 'address' } ],
          name: 'getEth2KeyRateOnWhichDebtWasPaidForCampaign',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getDebtsSummary',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'withdrawEtherCollected',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'withdraw2KEYCollected',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_dai', type: 'address' } ],
          name: 'withdrawDAICollected',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyFeeManager',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x2333847775b8fb5a554652a0f55b5e783eaebbc7',
           transactionHash:
            '0x02de9acdb287fe24c9c0d565bac087dd5076f4929b40d3f90e6ef0b60cc596bd',
           implementationAddressLogic: '0x2333847775b8fb5a554652a0f55b5e783eaebbc7',
           Proxy: '0x83dee8bb1185abb634b0339ee97513381ee75486',
           implementationAddressStorage: '0xba54a4a4238559d00ab35d280536577af54b9103',
           StorageProxy: '0xe79d62fb3331d43636ee2102ce54cb620e13b1b7' } } },
  TwoKeyMPSNMiningPool:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getContractBalance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonesRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_newWhitelistedAddress', type: 'address' } ],
          name: 'addWhitelistedAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_addressToBeRemovedFromWhitelist', type: 'address' } ],
          name: 'removeWhitelistedAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_address', type: 'address' } ],
          name: 'isAddressWhitelisted',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_receiver', type: 'address' },
             { name: '_amount', type: 'uint256' } ],
          name: 'transferTokensFromContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyMPSNMiningPool',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0xb366f2c6233a2e98977112e551b4e4ec90ca762a',
           transactionHash:
            '0x405c65f742d3dd08850f8f62b690630091fdc6db716a09862d39f3313d98e28d',
           implementationAddressLogic: '0xb366f2c6233a2e98977112e551b4e4ec90ca762a',
           Proxy: '0xcf34ce5f322c0d7881dbdd633564796e2b0344a2',
           implementationAddressStorage: '0xdc8b9628ed751742c1711bd0eed59a69f0882049',
           StorageProxy: '0x35ea6452b2951e84d1f06fff5cda7acd50222481' } } },
  TwoKeyMaintainersRegistry:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAllCoreDevs',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_id', type: 'uint256' } ],
          name: 'getCoreDevPerId',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAllMaintainers',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' },
             { name: '_maintainers', type: 'address[]' },
             { name: '_coreDevs', type: 'address[]' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_sender', type: 'address' } ],
          name: 'checkIsAddressMaintainer',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfCoreDevs',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfMaintainers',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_id', type: 'uint256' } ],
          name: 'getMaintainerPerId',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfActiveMaintainers',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_sender', type: 'address' } ],
          name: 'checkIsAddressCoreDev',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfActiveCoreDevs',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_maintainers', type: 'address[]' } ],
          name: 'addMaintainers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_coreDevs', type: 'address[]' } ],
          name: 'addCoreDevs',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_maintainers', type: 'address[]' } ],
          name: 'removeMaintainers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_coreDevs', type: 'address[]' } ],
          name: 'removeCoreDevs',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyMaintainersRegistry',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x8579970692bf77fafeeb017f07dec9a8fdb4893d',
           transactionHash:
            '0x8f3a1276c67c57a94f5755a1c2d829fc1d94b1e164b0c12996229be5b4d9975f',
           implementationAddressLogic: '0x8579970692bf77fafeeb017f07dec9a8fdb4893d',
           Proxy: '0x7e2a5f7e62c835f24668d322c9e328fa4a54398d',
           implementationAddressStorage: '0x2d9736f06006c0e3176626a89b6b0717e796e2a4',
           StorageProxy: '0xae757e3242ad97cc7f804c9bd7c344104bb6a78a' } } },
  TwoKeyNetworkGrowthFund:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getContractBalance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonesRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' },
             { name: '_twoKeyReleaseDate', type: 'uint256' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'overrideStoredPortionsWithRightValues',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_receiver', type: 'address' },
             { name: '_amount', type: 'uint256' },
             { name: '_portion', type: 'uint256' } ],
          name: 'transferPortion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_portion', type: 'uint256' } ],
          name: 'getPortionUnlockingDate',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_portion', type: 'uint256' } ],
          name: 'isPortionWithdrawn',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_portion', type: 'uint256' } ],
          name: 'getAmountLeftForThePortion',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyNetworkGrowthFund',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x7bb7ccc23a1acc4016344e315ca65b68998b570b',
           transactionHash:
            '0x29c1bb7d61e6ada34831cfcb826e6d986745864e3aee1685146bfb68de892d74',
           implementationAddressLogic: '0x7bb7ccc23a1acc4016344e315ca65b68998b570b',
           Proxy: '0x16d43f783cd83530aab052b1e099f861a84d4d34',
           implementationAddressStorage: '0xd0043ac71897032d572580ad84359323b5719068',
           StorageProxy: '0x75765ae698399687321591c330ddab96fe42578a' } } },
  TwoKeyParticipationMiningPool:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getContractBalance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'monthlyTransferAllowance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'initialAmountOfTokens',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'twoKeySingletonesRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'signatoryAddress', type: 'address' } ],
          name: 'setSignatoryAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_newWhitelistedAddress', type: 'address' } ],
          name: 'addWhitelistedAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_addressToBeRemovedFromWhitelist', type: 'address' } ],
          name: 'removeWhitelistedAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'dateStartingCountingMonths', type: 'uint256' } ],
          name: 'setWithdrawalParameters',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfTokens', type: 'uint256' } ],
          name: 'transferTokensToAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'signature', type: 'bytes' },
             { name: 'amountOfTokens', type: 'uint256' } ],
          name: 'withdrawTokensWithSignature',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_address', type: 'address' } ],
          name: 'isAddressWhitelisted',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'timestamp', type: 'uint256' } ],
          name: 'getAmountOfTokensUnlockedForWithdrawal',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'userAddress', type: 'address' },
             { name: 'amountOfTokens', type: 'uint256' },
             { name: 'signature', type: 'bytes' } ],
          name: 'recoverSignature',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'signature', type: 'bytes' } ],
          name: 'isExistingSignature',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getTotalAmountOfTokensTransfered',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getDateStartingCountingMonths',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getMonthlyTransferAllowance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getSignatoryAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyParticipationMiningPool',
     networks:
      { '1':
         { events: {},
           links: { Call: '0xeefce35a5f748ab47d574214897b90d5d09f6047' },
           address: '0xc28c68c810a0bb7fea42e99cabf04426eb0e21c2',
           transactionHash:
            '0xa9b8f0755c79cd865b6108797be2580fd6018ab980de8f28a21f7ffdadd63d04',
           implementationAddressLogic: '0xc28c68c810a0bb7fea42e99cabf04426eb0e21c2',
           Proxy: '0x5410a315ff0558c7a2013a8f04a68f50c42403ee',
           implementationAddressStorage: '0xfb7346b0bcde1304440526c17d5a1d2e9785513c',
           StorageProxy: '0x276de2f42cc7c1b6463d34d644980cc4a980f3a6' } } },
  TwoKeyParticipationPaymentsManager:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_twoKeyParticipationPaymentsManagerStorage',
               type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_newWhitelistedAddress', type: 'address' } ],
          name: 'addWhitelistedAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_addressToBeRemovedFromWhitelist', type: 'address' } ],
          name: 'removeWhitelistedAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_address', type: 'address' } ],
          name: 'isAddressWhitelisted',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfTokens', type: 'uint256' } ],
          name: 'transferTokensFromParticipationMiningPool',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_beneficiary', type: 'address' },
             { name: '_amount', type: 'uint256' } ],
          name: 'transferTokensFromContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAmountOfTokensReceivedFromParticipationMiningPool',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyParticipationPaymentsManager',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x33b0c71a080713cccdae2a1e9ce462f96d03fc19',
           transactionHash:
            '0x26b082b528786a3960fb32257eaf077ea05e6eb9141a47fa7d718632adc42539',
           implementationAddressLogic: '0x33b0c71a080713cccdae2a1e9ce462f96d03fc19',
           Proxy: '0x1ee8ab2a4e47cbef50c02068035a9382234db40c',
           implementationAddressStorage: '0xdac70a8c0a8eb714cd7fcbe526f96348b5f4e9c8',
           StorageProxy: '0x5373d413357712537524d998b36988128d1f9b41' } } },
  TwoKeyPlasmaBudgetCampaignsPaymentsHandler:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignPlasma', type: 'address' },
             { name: 'start', type: 'uint256' },
             { name: 'end', type: 'uint256' } ],
          name: 'markCampaignAsDoneAndAssignToActiveInfluencers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'referrers', type: 'address[]' },
             { name: 'currentRate2KEY', type: 'uint256' } ],
          name: 'rebalanceInfluencerRatesAndPrepareForRewardsDistribution',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'cycleId', type: 'uint256' },
             { name: 'feePerReferrerIn2KEY', type: 'uint256' } ],
          name: 'finishDistributionCycle',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'referrers', type: 'address[]' },
             { name: 'cycleId', type: 'uint256' } ],
          name: 'getPendingReferrersPaymentInformationForCycle',
          outputs:
           [ { name: '', type: 'uint256[]' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'referrer', type: 'address' } ],
          name: 'getCampaignsFinishedAndPaidForReferrer',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'referrer', type: 'address' } ],
          name: 'getCampaignsReferrerHasPendingBalances',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'referrer', type: 'address' } ],
          name: 'getTotalReferrerPendingAmount',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'referrer', type: 'address' } ],
          name: 'getCampaignsInProgressOfDistribution',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'referrer', type: 'address' },
             { name: 'cycleId', type: 'uint256' } ],
          name: 'getReferrerToTotalRebalancedAmountForCycleId',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'cycleId', type: 'uint256' } ],
          name: 'getTotalNonRebalancedPayoutForCycle',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'cycleId', type: 'uint256' } ],
          name: 'getTotalRebalancedPayoutForCycle',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfDistributionCycles',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'cycleId', type: 'uint256' } ],
          name: 'getReferrersForCycleId',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'referrer', type: 'address' },
             { name: 'cycleId', type: 'uint256' } ],
          name: 'getReferrerEarningsNonRebalancedPerCycle',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaBudgetCampaignsPaymentsHandler',
     networks:
      { '180':
         { events: {},
           links: {},
           address: '0x0a5d57d71bae89935d970efa777829be10936a72',
           transactionHash:
            '0x28cf69d6a903e18ae90310273fe57c26d789ebe3555372190938fb1ca2d5e180',
           implementationAddressLogic: '0x0a5d57d71bae89935d970efa777829be10936a72',
           Proxy: '0xa45f1dcb8d65c0073b764a88a47a16e0505e3773',
           implementationAddressStorage: '0xa406d07ea60658989c9edb85feebd3c423becd34',
           StorageProxy: '0x67e353e15ccf21da523d673d00e560f051f3ae9a' } } },
  TwoKeyPlasmaCongress:
   { abi:
      [ { constant: true,
          inputs: [ { name: '', type: 'uint256' } ],
          name: 'proposals',
          outputs:
           [ { name: 'recipient', type: 'address' },
             { name: 'amount', type: 'uint256' },
             { name: 'description', type: 'string' },
             { name: 'minExecutionDate', type: 'uint256' },
             { name: 'executed', type: 'bool' },
             { name: 'proposalPassed', type: 'bool' },
             { name: 'numberOfVotes', type: 'uint256' },
             { name: 'againstProposalTotal', type: 'uint256' },
             { name: 'supportingProposalTotal', type: 'uint256' },
             { name: 'proposalHash', type: 'bytes32' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'numProposals',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'debatingPeriodInMinutes',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'twoKeyCongressMembersRegistry',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs: [ { name: '_minutesForDebate', type: 'uint256' } ],
          payable: true,
          stateMutability: 'payable',
          type: 'constructor' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proposalID', type: 'uint256' },
             { indexed: false, name: 'recipient', type: 'address' },
             { indexed: false, name: 'amount', type: 'uint256' },
             { indexed: false, name: 'description', type: 'string' } ],
          name: 'ProposalAdded',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proposalID', type: 'uint256' },
             { indexed: false, name: 'position', type: 'bool' },
             { indexed: false, name: 'voter', type: 'address' },
             { indexed: false, name: 'justification', type: 'string' } ],
          name: 'Voted',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proposalID', type: 'uint256' },
             { indexed: false, name: 'quorum', type: 'uint256' },
             { indexed: false, name: 'active', type: 'bool' } ],
          name: 'ProposalTallied',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: '_newDebatingPeriodInMinutes',
               type: 'uint256' } ],
          name: 'ChangeOfRules',
          type: 'event' },
        { constant: false,
          inputs: [ { name: '_twoKeyCongressMembers', type: 'address' } ],
          name: 'setTwoKeyCongressMembersContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'beneficiary', type: 'address' },
             { name: 'weiAmount', type: 'uint256' },
             { name: 'jobDescription', type: 'string' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          name: 'newProposal',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'proposalNumber', type: 'uint256' },
             { name: 'beneficiary', type: 'address' },
             { name: 'weiAmount', type: 'uint256' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          name: 'checkProposalCode',
          outputs: [ { name: 'codeChecksOut', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proposalNumber', type: 'uint256' },
             { name: 'supportsProposal', type: 'bool' },
             { name: 'justificationText', type: 'string' } ],
          name: 'vote',
          outputs: [ { name: 'voteID', type: 'uint256' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'proposalNumber', type: 'uint256' } ],
          name: 'getVoteCount',
          outputs:
           [ { name: 'numberOfVotes', type: 'uint256' },
             { name: 'supportingProposalTotal', type: 'uint256' },
             { name: 'againstProposalTotal', type: 'uint256' },
             { name: 'description', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proposalNumber', type: 'uint256' },
             { name: 'transactionBytecode', type: 'bytes' } ],
          name: 'executeProposal',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'proposalId', type: 'uint256' } ],
          name: 'getProposalData',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'string' },
             { name: '', type: 'uint256' },
             { name: '', type: 'bool' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaCongress',
     networks:
      { '180':
         { events: {},
           links: {},
           address: '0xf62ae1f14950dc1042c8683f8ed4b572927ca57c',
           transactionHash:
            '0x294b7132e4b8fe3515bacd5e65f8537a602e4d0ca2ea5388565833a5fbf1749a' } } },
  TwoKeyPlasmaCongressMembersRegistry:
   { abi:
      [ { constant: true,
          inputs: [ { name: '', type: 'address' } ],
          name: 'isMemberInCongress',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'minimumQuorum',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_CONGRESS',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '', type: 'address' } ],
          name: 'address2Member',
          outputs:
           [ { name: 'memberAddress', type: 'address' },
             { name: 'name', type: 'bytes32' },
             { name: 'votingPower', type: 'uint256' },
             { name: 'memberSince', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'maxVotingPower',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '', type: 'uint256' } ],
          name: 'allMembers',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs:
           [ { name: 'initialCongressMembers', type: 'address[]' },
             { name: 'initialCongressMemberNames', type: 'bytes32[]' },
             { name: 'memberVotingPowers', type: 'uint256[]' },
             { name: '_twoKeyCongress', type: 'address' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'constructor' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'member', type: 'address' },
             { indexed: false, name: 'isMember', type: 'bool' } ],
          name: 'MembershipChanged',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: 'targetMember', type: 'address' },
             { name: 'memberName', type: 'bytes32' },
             { name: '_votingPower', type: 'uint256' } ],
          name: 'addMember',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'targetMember', type: 'address' } ],
          name: 'removeMember',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_memberAddress', type: 'address' } ],
          name: 'getMemberVotingPower',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_address', type: 'address' } ],
          name: 'isMember',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getMembersLength',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAllMemberAddresses',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getMemberInfo',
          outputs:
           [ { name: '', type: 'address' },
             { name: '', type: 'bytes32' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaCongressMembersRegistry',
     networks:
      { '180':
         { events: {},
           links: {},
           address: '0x2061341cb7e53450ca3e998398f2944c99b27547',
           transactionHash:
            '0x70eafa4ed69213d4d47af9f90ae2d40ec66198ffd22462b84f11c0ad75b16fb4' } } },
  TwoKeyPlasmaEventSource:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'plasma', type: 'address' },
             { indexed: false, name: 'eth', type: 'address' } ],
          name: 'Plasma2Ethereum',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'plasma', type: 'address' },
             { indexed: false, name: 'handle', type: 'string' } ],
          name: 'Plasma2Handle',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'campaignAddressPlasma',
               type: 'address' },
             { indexed: false,
               name: 'campaignAddressPublic',
               type: 'address' },
             { indexed: false, name: 'conversionID', type: 'uint256' },
             { indexed: false, name: 'contractor', type: 'address' },
             { indexed: false, name: 'converter', type: 'address' } ],
          name: 'ConversionCreated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'campaignAddressPlasma',
               type: 'address' },
             { indexed: false, name: 'conversionID', type: 'uint256' } ],
          name: 'ConversionExecuted',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'campaignAddressPlasma',
               type: 'address' },
             { indexed: false, name: 'conversionID', type: 'uint256' } ],
          name: 'ConversionPaid',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'campaignAddressPlasma',
               type: 'address' },
             { indexed: false, name: 'conversionID', type: 'uint256' },
             { indexed: false, name: 'statusCode', type: 'uint256' } ],
          name: 'ConversionRejected',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false,
               name: 'proxyCPCCampaignPlasma',
               type: 'address' },
             { indexed: false, name: 'contractorPlasma', type: 'address' } ],
          name: 'CPCCampaignCreated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'proxyPlasmaAddress', type: 'address' },
             { indexed: false, name: 'proxyPublicAddress', type: 'address' } ],
          name: 'PlasmaMirrorCampaigns',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'contractAddress', type: 'address' },
             { indexed: false, name: 'influencer', type: 'address' },
             { indexed: false, name: 'rewards', type: 'uint256' } ],
          name: 'AddedPendingRewards',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'influencer', type: 'address' },
             { indexed: false, name: 'nonRebalancedRewards', type: 'uint256' },
             { indexed: false, name: 'rewards', type: 'uint256' },
             { indexed: false, name: 'campaignsPaid', type: 'address[]' },
             { indexed: false,
               name: 'earningsPerCampaign',
               type: 'uint256[]' },
             { indexed: false, name: 'feePerReferrer2KEY', type: 'uint256' } ],
          name: 'PaidPendingRewards',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'userPlasmaAddress', type: 'address' },
             { indexed: false, name: 'newHandle', type: 'string' } ],
          name: 'HandleChanged',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'epochId', type: 'uint256' },
             { indexed: false, name: 'user', type: 'address' },
             { indexed: false, name: 'reward2KeyWei', type: 'uint256' } ],
          name: 'RewardsAssignedToUserInParticipationMiningEpoch',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'epochId', type: 'uint256' },
             { indexed: false, name: 'totalRewardsInEpoch', type: 'uint256' } ],
          name: 'EpochDeclared',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'epochId', type: 'uint256' },
             { indexed: false, name: 'numberOfUsers', type: 'uint256' } ],
          name: 'EpochRegistered',
          type: 'event' },
        { anonymous: false,
          inputs: [ { indexed: false, name: 'epochId', type: 'uint256' } ],
          name: 'EpochFinalized',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignAddressPublic', type: 'address' },
             { name: 'conversionID', type: 'uint256' },
             { name: 'contractor', type: 'address' },
             { name: 'converter', type: 'address' } ],
          name: 'emitConversionCreatedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'conversionID', type: 'uint256' } ],
          name: 'emitConversionExecutedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'conversionID', type: 'uint256' } ],
          name: 'emitConversionPaidEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'conversionID', type: 'uint256' },
             { name: 'statusCode', type: 'uint256' } ],
          name: 'emitConversionRejectedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proxyCPCCampaignPlasma', type: 'address' },
             { name: 'contractorPlasma', type: 'address' } ],
          name: 'emitCPCCampaignCreatedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'proxyAddressPlasma', type: 'address' },
             { name: 'proxyAddressPublic', type: 'address' } ],
          name: 'emitCPCCampaignMirrored',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasma', type: 'address' },
             { name: '_ethereum', type: 'address' } ],
          name: 'emitPlasma2EthereumEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasma', type: 'address' },
             { name: '_handle', type: 'string' } ],
          name: 'emitPlasma2HandleEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_userPlasmaAddress', type: 'address' },
             { name: '_newHandle', type: 'string' } ],
          name: 'emitHandleChangedEvent',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignPlasma', type: 'address' },
             { name: 'influencer', type: 'address' },
             { name: 'amountOfTokens', type: 'uint256' } ],
          name: 'emitAddedPendingRewards',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'influencer', type: 'address' },
             { name: 'amountNonRebalancedEarned', type: 'uint256' },
             { name: 'amountPaid', type: 'uint256' },
             { name: 'campaignsPaid', type: 'address[]' },
             { name: 'earningsPerCampaign', type: 'uint256[]' },
             { name: 'feePerReferrer2KEY', type: 'uint256' } ],
          name: 'emitPaidPendingRewards',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'epochId', type: 'uint256' },
             { name: 'user', type: 'address' },
             { name: 'reward2KeyWei', type: 'uint256' } ],
          name: 'emitRewardsAssignedToUserInParticipationMiningEpoch',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'epochId', type: 'uint256' },
             { name: 'totalRewardsInEpoch', type: 'uint256' } ],
          name: 'emitEpochDeclared',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'epochId', type: 'uint256' },
             { name: 'numberOfUsers', type: 'uint256' } ],
          name: 'emitEpochRegistered',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'epochId', type: 'uint256' } ],
          name: 'emitEpochFinalized',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyPlasmaEventSource',
     networks:
      { '180':
         { events: {},
           links: {},
           address: '0x8c3043a172156069434e4e65db695e2f7071ca6c',
           transactionHash:
            '0x89cfb65b8ddbce456f0f99cc2801a8d060978c3b53d2ca26a69033d16c84652c',
           implementationAddressLogic: '0x8c3043a172156069434e4e65db695e2f7071ca6c',
           Proxy: '0x4e2702ec637b586ad75d707ebb6ee75334cec480',
           implementationAddressStorage: '0x5af8baf72e380625a063d71d97222367519803bb',
           StorageProxy: '0x662feba2a61779a84b1deea7d1c626ff2b01ece6' } } },
  TwoKeyPlasmaEvents:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: true, name: 'to', type: 'address' },
             { indexed: true, name: 'c', type: 'address' },
             { indexed: true, name: 'contractor', type: 'address' },
             { indexed: false, name: 'from', type: 'address' } ],
          name: 'Visited',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'campaignAddress', type: 'address' },
             { indexed: false, name: 'fromPlasma', type: 'address' },
             { indexed: false, name: 'toPlasma', type: 'address' } ],
          name: 'Joined',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'new_public_key', type: 'address' } ],
          name: 'setPublicLinkKey',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'cut', type: 'uint256' } ],
          name: 'setCut',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'me', type: 'address' } ],
          name: 'cutOf',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'me', type: 'address' } ],
          name: 'publicLinkKeyOf',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'note', type: 'bytes' } ],
          name: 'setNoteByUser',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: '_plasma', type: 'address' } ],
          name: 'notes',
          outputs: [ { name: '', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignAddress', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'sig', type: 'bytes' } ],
          name: 'joinCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'sig', type: 'bytes' } ],
          name: 'visited',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: 'from', type: 'address' } ],
          name: 'visitsListEx',
          outputs:
           [ { name: '', type: 'address[]' },
             { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignAddress', type: 'address' } ],
          name: 'getNumberOfVisitsAndJoinsAndForwarders',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'c', type: 'address' },
             { name: 'contractor', type: 'address' },
             { name: '_address', type: 'address' } ],
          name: 'getVisitedFrom',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_c', type: 'address' },
             { name: '_contractor', type: 'address' },
             { name: '_address', type: 'address' } ],
          name: 'getJoinedFrom',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_c', type: 'address' },
             { name: '_contractor', type: 'address' },
             { name: '_referrer', type: 'address' } ],
          name: 'getVisitsListTimestamps',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaEvents',
     networks:
      { '180':
         { events: {},
           links: { Call: '0xa4da7bda81aba94c0e555c3b6c36d733987e3226' },
           address: '0x268c5889f7bc51f3dc72404c552bd2d21e22318a',
           transactionHash:
            '0x4dfc0f7f7605639205570d8eb1253fa07eb1c083d1ad9891ecf475c33f96235a',
           implementationAddressLogic: '0x268c5889f7bc51f3dc72404c552bd2d21e22318a',
           Proxy: '0x039fbbb9cb6f898480cc292f04d546d4224145d9',
           implementationAddressStorage: '0x97d705e4234864b304457773f3cad90799c24a25',
           StorageProxy: '0xb51b8a93f5dfbf260d388caac0643f4469c267ef' } } },
  TwoKeyPlasmaFactory:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignType', type: 'string' } ],
          name: 'getLatestApprovedCampaignVersion',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_url', type: 'string' },
             { name: 'numberValuesArray', type: 'uint256[]' },
             { name: '_nonSingletonHash', type: 'string' } ],
          name: 'createPlasmaCPCCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_url', type: 'string' },
             { name: 'numberValuesArray', type: 'uint256[]' },
             { name: '_nonSingletonHash', type: 'string' } ],
          name: 'createPlasmaCPCNoRewardsCampaign',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_campaignAddress', type: 'address' } ],
          name: 'isCampaignCreatedThroughFactory',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignAddress', type: 'address' } ],
          name: 'getNonSingletonHashForCampaign',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_key', type: 'address' } ],
          name: 'addressToCampaignType',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaFactory',
     networks:
      { '180':
         { events: {},
           links: {},
           address: '0x9cb27b67cdee9782ccc188acaa072b19b3934c65',
           transactionHash:
            '0x1c868b34fcf71e20bfa77f439bb96da307dea90a911b2b1d4a81a44770159f6d',
           implementationAddressLogic: '0x9cb27b67cdee9782ccc188acaa072b19b3934c65',
           Proxy: '0x0b2dba48892352a6305d25eb921761909ea88416',
           implementationAddressStorage: '0xbc91eeb528d6e63175573cdbb90cb1fa6b934802',
           StorageProxy: '0x5c9144975fb781c5262ca944d08df5bafd0e61eb' } } },
  TwoKeyPlasmaMaintainersRegistry:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAllCoreDevs',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_id', type: 'uint256' } ],
          name: 'getCoreDevPerId',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getAllMaintainers',
          outputs: [ { name: '', type: 'address[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' },
             { name: '_maintainers', type: 'address[]' },
             { name: '_coreDevs', type: 'address[]' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_sender', type: 'address' } ],
          name: 'checkIsAddressMaintainer',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfCoreDevs',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfMaintainers',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_id', type: 'uint256' } ],
          name: 'getMaintainerPerId',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfActiveMaintainers',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_sender', type: 'address' } ],
          name: 'checkIsAddressCoreDev',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getNumberOfActiveCoreDevs',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_maintainers', type: 'address[]' } ],
          name: 'addMaintainers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_coreDevs', type: 'address[]' } ],
          name: 'addCoreDevs',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_maintainers', type: 'address[]' } ],
          name: 'removeMaintainers',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_coreDevs', type: 'address[]' } ],
          name: 'removeCoreDevs',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getCongressAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaMaintainersRegistry',
     networks:
      { '180':
         { events: {},
           links: {},
           address: '0xe26597eed657533aede5e195a8f248f3af95817b',
           transactionHash:
            '0x0f7e1adb45f6528eb45d1d5dd26d44bda94895ef9fa40e6a087650a3aafb81cf',
           implementationAddressLogic: '0xe26597eed657533aede5e195a8f248f3af95817b',
           Proxy: '0xc13c57a5c488211b26c7fb63db091d78d5c3ae47',
           implementationAddressStorage: '0xc29e734d86723f91119be45e6a8f5f189757a19b',
           StorageProxy: '0x3b156b4140b840f728d84aa326b664d45070d6a7' } } },
  TwoKeyPlasmaParticipationRewards:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'epochIds', type: 'uint256[]' },
             { name: 'totalRewardsPerEpoch', type: 'uint256[]' } ],
          name: 'declareEpochs',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'epochId', type: 'uint256' },
             { name: 'numberOfUsers', type: 'uint256' } ],
          name: 'registerEpoch',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'epochId', type: 'uint256' },
             { name: 'users', type: 'address[]' },
             { name: 'rewards', type: 'uint256[]' } ],
          name: 'assignRewardsInActiveMiningEpoch',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'epochId', type: 'uint256' } ],
          name: 'finalizeEpoch',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'epochId', type: 'uint256' },
             { name: 'rewardsAmount', type: 'uint256' } ],
          name: 'redeclareRewardsAmountForEpoch',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'userPublicAddress', type: 'address' },
             { name: 'totalRewardsPending', type: 'uint256' },
             { name: 'signature', type: 'bytes' } ],
          name: 'submitSignatureForUserWithdrawal',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'userPlasma', type: 'address' },
             { name: 'signature', type: 'bytes' } ],
          name: 'markUserFinishedWithdrawalFromMainchainWithSignature',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'signatoryAddress', type: 'address' } ],
          name: 'setSignatoryAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'userAddress', type: 'address' },
             { name: 'totalRewardsPending', type: 'uint256' },
             { name: 'signature', type: 'bytes' } ],
          name: 'recoverSignature',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'user', type: 'address' },
             { name: 'epochId', type: 'uint256' } ],
          name: 'getUserEarningsPerEpoch',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'user', type: 'address' } ],
          name: 'getUserTotalPendingAmount',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'user', type: 'address' } ],
          name: 'getUserTotalWithdrawnAmount',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'user', type: 'address' } ],
          name: 'getPendingEpochsForUser',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'user', type: 'address' } ],
          name: 'getWithdrawnEpochsForUser',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'epochId', type: 'uint256' } ],
          name: 'getTotalRewardsPerEpoch',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getLatestFinalizedEpochId',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'epochId', type: 'uint256' } ],
          name: 'isEpochRegistrationFinalized',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'user', type: 'address' } ],
          name: 'getUserPendingSignature',
          outputs: [ { name: '', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'user', type: 'address' },
             { name: 'signature', type: 'bytes' } ],
          name: 'getAmountUserWithdrawnUsingSignature',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'user', type: 'address' } ],
          name: 'getHowMuchUserHaveInProgressOfWithdrawal',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getEpochIdInProgress',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'epochId', type: 'uint256' } ],
          name: 'getTotalUsersInEpoch',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'epochId', type: 'uint256' } ],
          name: 'getTotalRewardsToBeAssignedInEpoch',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getDeclaredEpochIds',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getSignatoryAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'epochId', type: 'uint256' } ],
          name: 'isEpochIdDeclared',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaParticipationRewards',
     networks:
      { '180':
         { events: {},
           links: { Call: '0xa4da7bda81aba94c0e555c3b6c36d733987e3226' },
           address: '0x42819c1f9a8bf2b25cb52e9d5b5e5f0326a4c5ff',
           transactionHash:
            '0xb0f9b02bffc6fc3d7a5c2a6bb343bec9b074cfc365e0061cd9da6484192a6cf4',
           implementationAddressLogic: '0x42819c1f9a8bf2b25cb52e9d5b5e5f0326a4c5ff',
           Proxy: '0xfd5e5de4787b301739e05853ba31dd194e4f180c',
           implementationAddressStorage: '0x47dc02d28786a5836bebfce6577dfa6d8ad0f131',
           StorageProxy: '0xd5af5119686e73c7d28ce2b4eb3c263eacf211e7' } } },
  TwoKeyPlasmaRegistry:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'plasmaAddress', type: 'address' },
             { name: 'username', type: 'string' } ],
          name: 'linkUsernameAndAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'plasmaAddress', type: 'address' },
             { name: 'username', type: 'string' } ],
          name: 'changeLinkedUsernameForAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'signature', type: 'bytes' },
             { name: 'plasmaAddress', type: 'address' },
             { name: 'ethereumAddress', type: 'address' } ],
          name: 'addPlasma2Ethereum',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'newUsername', type: 'string' },
             { name: 'userPublicAddress', type: 'address' } ],
          name: 'changeUsername',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'feePercentage', type: 'uint256' } ],
          name: 'setModeratorFee',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasma', type: 'address' } ],
          name: 'plasma2ethereum',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_ethereum', type: 'address' } ],
          name: 'ethereum2plasma',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_address', type: 'address' } ],
          name: 'getAddressToUsername',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_username', type: 'string' } ],
          name: 'getUsernameToAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'signature', type: 'bytes' } ],
          name: 'recover',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getModeratorFee',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaRegistry',
     networks:
      { '180':
         { events: {},
           links: { Call: '0xa4da7bda81aba94c0e555c3b6c36d733987e3226' },
           address: '0x733734f5da91810f9d8d428fc5b079527c3fbcec',
           transactionHash:
            '0x0f1771fec3c4b591b73a49aa33ef3754d658735d231b9cfe4171a81ae0769f67',
           implementationAddressLogic: '0x733734f5da91810f9d8d428fc5b079527c3fbcec',
           Proxy: '0x7bcd4b4e1594882106d384f9ee87725a2be1ca20',
           implementationAddressStorage: '0xfe6b39e9e62d015e76ffc8b6870fcb8894a87afe',
           StorageProxy: '0x4595c09dc4e4499881d0ef88a6e8242d74d196eb' } } },
  TwoKeyPlasmaReputationRegistry:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_PLASMA_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_plasmaAddress', type: 'address' },
             { indexed: false, name: '_role', type: 'string' },
             { indexed: false, name: '_type', type: 'string' },
             { indexed: false, name: '_points', type: 'int256' },
             { indexed: false, name: '_campaignAddress', type: 'address' } ],
          name: 'ReputationUpdated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_plasmaAddress', type: 'address' },
             { indexed: false, name: '_role', type: 'string' },
             { indexed: false, name: '_type', type: 'string' },
             { indexed: false, name: '_points', type: 'int256' },
             { indexed: false, name: '_reporterPlasma', type: 'address' },
             { indexed: false, name: '_campaignAddress', type: 'address' } ],
          name: 'FeedbackSubmitted',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyPlasmaSingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_role', type: 'string' },
             { name: '_type', type: 'string' },
             { name: '_pointsGained', type: 'int256' },
             { name: '_reporterPlasma', type: 'address' },
             { name: '_campaignAddress', type: 'address' } ],
          name: 'addPositiveFeedbackByMaintainer',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_plasmaAddress', type: 'address' },
             { name: '_role', type: 'string' },
             { name: '_type', type: 'string' },
             { name: '_pointsLost', type: 'int256' },
             { name: '_reporterPlasma', type: 'address' },
             { name: '_campaignAddress', type: 'address' } ],
          name: 'addNegativeFeedbackByMaintainer',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'converter', type: 'address' },
             { name: 'contractor', type: 'address' } ],
          name: 'updateReputationPointsForExecutedConversion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'converter', type: 'address' },
             { name: 'contractor', type: 'address' } ],
          name: 'updateReputationPointsForRejectedConversions',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'updateUserReputationScoreOnSignup',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getReputationForUser',
          outputs:
           [ { name: '', type: 'int256' },
             { name: '', type: 'int256' },
             { name: '', type: 'int256' },
             { name: '', type: 'int256' },
             { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getGlobalReputationForUser',
          outputs: [ { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getReputationForContractor',
          outputs:
           [ { name: '', type: 'int256' },
             { name: '', type: 'int256' },
             { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getGlobalReputationForContractor',
          outputs: [ { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'addresses', type: 'address[]' } ],
          name: 'getGlobalReputationForUsers',
          outputs: [ { name: '', type: 'int256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'addresses', type: 'address[]' } ],
          name: 'getGlobalReputationForContractors',
          outputs: [ { name: '', type: 'int256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_plasmaAddress', type: 'address' } ],
          name: 'getUserSignupScore',
          outputs: [ { name: '', type: 'int256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyPlasmaReputationRegistry',
     networks:
      { '180':
         { events: {},
           links: {},
           address: '0x61137ebbcd254fb4e52c47cd065ea6325a255288',
           transactionHash:
            '0x9d6b7bf9086c931adeb8553da8372f6851bb1c27adcbd1c2cbdec9e6bdb67de2',
           implementationAddressLogic: '0x61137ebbcd254fb4e52c47cd065ea6325a255288',
           Proxy: '0xdd2209edb96128b5856b70cb6eca1d5bef183908',
           implementationAddressStorage: '0x6a2fd3ebc404225cacd5359ad885c9461648a0b0',
           StorageProxy: '0xac920355fb698d693fd8f5735f469d929145ca06' } } },
  TwoKeyPlasmaSingletoneRegistry:
   { abi:
      [ { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'contractNameStorage', type: 'string' },
             { name: 'version', type: 'string' } ],
          name: 'createProxy',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'version', type: 'string' } ],
          name: 'getVersion',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'version', type: 'string' } ],
          name: 'upgradeContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'version', type: 'string' },
             { name: 'implementation', type: 'address' } ],
          name: 'addVersion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'campaignType', type: 'string' } ],
          name: 'approveCampaignVersionDuringCreation',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'contractName', type: 'string' } ],
          name: 'getLatestAddedContractVersion',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'contractAddress', type: 'address' } ],
          name: 'addNonUpgradableContractToAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignType', type: 'string' } ],
          name: 'getLatestCampaignApprovedVersion',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignType', type: 'string' },
             { name: 'versionToApprove', type: 'string' } ],
          name: 'approveCampaignVersion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'deployer',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'contractAddress', type: 'address' } ],
          name: 'changeNonUpgradableContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractName', type: 'string' } ],
          name: 'getContractProxyAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractLogicName', type: 'string' },
             { name: 'contractStorageName', type: 'string' },
             { name: 'contractLogicImplementation', type: 'address' },
             { name: 'contractStorageImplementation', type: 'address' },
             { name: 'version', type: 'string' } ],
          name: 'addVersionDuringCreation',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_newOwner', type: 'address' } ],
          name: 'transferOwnership',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'contractName', type: 'string' } ],
          name: 'getNonUpgradableContractAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'constructor' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'logicProxy', type: 'address' },
             { indexed: false, name: 'storageProxy', type: 'address' } ],
          name: 'ProxiesDeployed',
          type: 'event' },
        { anonymous: false,
          inputs: [ { indexed: false, name: 'proxy', type: 'address' } ],
          name: 'ProxyCreated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'version', type: 'string' },
             { indexed: false, name: 'implementation', type: 'address' },
             { indexed: false, name: 'contractName', type: 'string' } ],
          name: 'VersionAdded',
          type: 'event' } ],
     name: 'TwoKeyPlasmaSingletoneRegistry',
     networks:
      { '180':
         { events:
            { '0x4f77447014a5aac8b38888b4720a78a43d44a6301dbf1b456c1da3715d5a5df4':
               { anonymous: false,
                 inputs:
                  [ { indexed: false, name: 'logicProxy', type: 'address' },
                    { indexed: false, name: 'storageProxy', type: 'address' } ],
                 name: 'ProxiesDeployed',
                 type: 'event' },
              '0x00fffc2da0b561cae30d9826d37709e9421c4725faebc226cbbb7ef5fc5e7349':
               { anonymous: false,
                 inputs: [ { indexed: false, name: 'proxy', type: 'address' } ],
                 name: 'ProxyCreated',
                 type: 'event' },
              '0x81842de01aaeaf0825ef7073ad6520baccb9fa3a19dff82385d66e14f6f1e4a8':
               { anonymous: false,
                 inputs:
                  [ { indexed: false, name: 'version', type: 'string' },
                    { indexed: false, name: 'implementation', type: 'address' },
                    { indexed: false, name: 'contractName', type: 'string' } ],
                 name: 'VersionAdded',
                 type: 'event' } },
           links: {},
           address: '0xd0043ac71897032d572580ad84359323b5719068',
           transactionHash:
            '0x4808ecf9ffb15d3cfd28fdc1fafb036f6f378dc321a6536407339fd9ac6f73e0' } } },
  TwoKeyRegistry:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonesRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'signature', type: 'bytes' },
             { name: 'username', type: 'string' },
             { name: 'ethereumAddress', type: 'address' },
             { name: 'plasmaAddress', type: 'address' } ],
          name: 'registerUserByMaintainer',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'newUsername', type: 'string' },
             { name: 'userPublicAddress', type: 'address' } ],
          name: 'changeUsername',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_username', type: 'string' } ],
          name: 'getUserName2UserAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'plasmaAddress', type: 'address' } ],
          name: 'getPlasmaToEthereum',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'ethereumAddress', type: 'address' } ],
          name: 'getEthereumToPlasma',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_userAddress', type: 'address' } ],
          name: 'checkIfUserExists',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_userAddress', type: 'address' } ],
          name: 'getUserData',
          outputs: [ { name: '', type: 'bytes' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'keyAddress', type: 'address' } ],
          name: 'address2username',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_username', type: 'bytes32' } ],
          name: 'username2currentAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyRegistry',
     networks:
      { '1':
         { events: {},
           links: { Call: '0xeefce35a5f748ab47d574214897b90d5d09f6047' },
           address: '0xa791ae83974af17ce4207a5f86d44a0356abe97b',
           transactionHash:
            '0x9ad6bfc5d85d7d07a135777285a2e3641ff6544eaa17759ac3faac1642b576aa',
           implementationAddressLogic: '0xa791ae83974af17ce4207a5f86d44a0356abe97b',
           Proxy: '0xdbbbc433ebcd238d4ae61d12d27130c078547d23',
           implementationAddressStorage: '0x54d710d902ae972bce96922f544243067575d176',
           StorageProxy: '0x467b063235c4b5be423952135089d73792d26505' } } },
  TwoKeySignatureValidator:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorage', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_name', type: 'string' },
             { name: '_fullName', type: 'string' },
             { name: '_email', type: 'string' },
             { name: 'signature', type: 'bytes' } ],
          name: 'validateSignUserData',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_name', type: 'string' },
             { name: 'signature', type: 'bytes' } ],
          name: 'validateSignName',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'username', type: 'string' },
             { name: '_username_walletName', type: 'string' },
             { name: 'signature', type: 'bytes' } ],
          name: 'validateSignWalletName',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'plasmaAddress', type: 'address' },
             { name: 'signature', type: 'bytes' } ],
          name: 'validatePlasmaToEthereum',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'pure',
          type: 'function' } ],
     name: 'TwoKeySignatureValidator',
     networks:
      { '1':
         { events: {},
           links: { Call: '0xeefce35a5f748ab47d574214897b90d5d09f6047' },
           address: '0x140508f4f00a7380f254afde5615719dc54352e5',
           transactionHash:
            '0xe2fc5f3df62eda0f7a29baba8d060ab2ed65f0827f306ee4e04ce347ec465d53',
           implementationAddressLogic: '0x140508f4f00a7380f254afde5615719dc54352e5',
           Proxy: '0x09b30d7eb2314b9b29e2b258528887acb19c3223',
           implementationAddressStorage: '0xf0329de61a4b674a46e78a2cbb1fc28586b283d1',
           StorageProxy: '0x40c258f2fcbe0a3b61a60e2a5a6e9d71ab7862ce' } } },
  TwoKeySingletonesRegistry:
   { abi:
      [ { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'contractNameStorage', type: 'string' },
             { name: 'version', type: 'string' } ],
          name: 'createProxy',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'version', type: 'string' } ],
          name: 'getVersion',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'version', type: 'string' } ],
          name: 'upgradeContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'version', type: 'string' },
             { name: 'implementation', type: 'address' } ],
          name: 'addVersion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'campaignType', type: 'string' } ],
          name: 'approveCampaignVersionDuringCreation',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'contractName', type: 'string' } ],
          name: 'getLatestAddedContractVersion',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'contractAddress', type: 'address' } ],
          name: 'addNonUpgradableContractToAddress',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'campaignType', type: 'string' } ],
          name: 'getLatestCampaignApprovedVersion',
          outputs: [ { name: '', type: 'string' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'campaignType', type: 'string' },
             { name: 'versionToApprove', type: 'string' } ],
          name: 'approveCampaignVersion',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'deployer',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractName', type: 'string' },
             { name: 'contractAddress', type: 'address' } ],
          name: 'changeNonUpgradableContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractName', type: 'string' } ],
          name: 'getContractProxyAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'contractLogicName', type: 'string' },
             { name: 'contractStorageName', type: 'string' },
             { name: 'contractLogicImplementation', type: 'address' },
             { name: 'contractStorageImplementation', type: 'address' },
             { name: 'version', type: 'string' } ],
          name: 'addVersionDuringCreation',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_newOwner', type: 'address' } ],
          name: 'transferOwnership',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'contractName', type: 'string' } ],
          name: 'getNonUpgradableContractAddress',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { inputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'constructor' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'logicProxy', type: 'address' },
             { indexed: false, name: 'storageProxy', type: 'address' } ],
          name: 'ProxiesDeployed',
          type: 'event' },
        { anonymous: false,
          inputs: [ { indexed: false, name: 'proxy', type: 'address' } ],
          name: 'ProxyCreated',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'version', type: 'string' },
             { indexed: false, name: 'implementation', type: 'address' },
             { indexed: false, name: 'contractName', type: 'string' } ],
          name: 'VersionAdded',
          type: 'event' } ],
     name: 'TwoKeySingletonesRegistry',
     networks:
      { '1':
         { events:
            { '0x4f77447014a5aac8b38888b4720a78a43d44a6301dbf1b456c1da3715d5a5df4':
               { anonymous: false,
                 inputs:
                  [ { indexed: false, name: 'logicProxy', type: 'address' },
                    { indexed: false, name: 'storageProxy', type: 'address' } ],
                 name: 'ProxiesDeployed',
                 type: 'event' },
              '0x00fffc2da0b561cae30d9826d37709e9421c4725faebc226cbbb7ef5fc5e7349':
               { anonymous: false,
                 inputs: [ { indexed: false, name: 'proxy', type: 'address' } ],
                 name: 'ProxyCreated',
                 type: 'event' },
              '0x81842de01aaeaf0825ef7073ad6520baccb9fa3a19dff82385d66e14f6f1e4a8':
               { anonymous: false,
                 inputs:
                  [ { indexed: false, name: 'version', type: 'string' },
                    { indexed: false, name: 'implementation', type: 'address' },
                    { indexed: false, name: 'contractName', type: 'string' } ],
                 name: 'VersionAdded',
                 type: 'event' } },
           links: {},
           address: '0x60ece4a5be3fd7594e9f24c2948cce5ce3c6dde7',
           transactionHash:
            '0x0d84884bbe03b3db154656b7d61e578b634be95845c09740dca6fa7319b8c0e3' } } },
  TwoKeyTeamGrowthFund:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getContractBalance',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeySingletonRegistry', type: 'address' },
             { name: '_proxyStorageContract', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'getTokensReleaseDate',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_beneficiary', type: 'address' },
             { name: '_amount', type: 'uint256' } ],
          name: 'transferTokensFromContract',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' } ],
     name: 'TwoKeyTeamGrowthFund',
     networks:
      { '1':
         { events: {},
           links: {},
           address: '0x8ba42c46aa1004a81ba9b99129a86d3ecb8968e5',
           transactionHash:
            '0xfcd4497f52f6363735e82c0c1d43e160e599d5e88525bdf9d7f4ee7ba8ec87d5',
           implementationAddressLogic: '0x8ba42c46aa1004a81ba9b99129a86d3ecb8968e5',
           Proxy: '0x4cf76ad9b2805f97d376ecaaa9af7fe0e6bdc400',
           implementationAddressStorage: '0xeda96dedc0fa92d76444156aa1b4eb474d38599d',
           StorageProxy: '0xdfc983f7dcb9bedd9f1456f0236021349da44851' } } },
  TwoKeyUpgradableExchange:
   { abi:
      [ { constant: true,
          inputs: [],
          name: 'PROXY_STORAGE_CONTRACT',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'implementation',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'TWO_KEY_SINGLETON_REGISTRY',
          outputs: [ { name: '', type: 'address' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'sender', type: 'address' } ],
          name: 'initialize',
          outputs: [],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { payable: true, stateMutability: 'payable', type: 'fallback' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: 'caller', type: 'address' },
             { indexed: false, name: 'beneficiary', type: 'address' },
             { indexed: false,
               name: 'stableCoinsReserveBefore',
               type: 'uint256' },
             { indexed: false,
               name: 'stableCoinsReserveAfter',
               type: 'uint256' },
             { indexed: false, name: 'etherBalanceBefore', type: 'uint256' },
             { indexed: false, name: 'etherBalanceAfter', type: 'uint256' },
             { indexed: false,
               name: 'stableCoinsToWithdraw',
               type: 'uint256' },
             { indexed: false, name: 'twoKeyAmount', type: 'uint256' } ],
          name: 'WithdrawExecuted',
          type: 'event' },
        { anonymous: false,
          inputs:
           [ { indexed: false, name: '_daisReceived', type: 'uint256' },
             { indexed: false, name: '_ratio', type: 'uint256' },
             { indexed: false, name: '_numberOfContracts', type: 'uint256' } ],
          name: 'HedgedEther',
          type: 'event' },
        { constant: false,
          inputs:
           [ { name: '_daiAddress', type: 'address' },
             { name: '_kyberNetworkProxyAddress', type: 'address' },
             { name: '_twoKeySingletonesRegistry', type: 'address' },
             { name: '_proxyStorageContract', type: 'address' } ],
          name: 'setInitialParams',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'startIndex', type: 'uint256' },
             { name: 'endIndex', type: 'uint256' } ],
          name: 'calculateSumOnContracts',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractAddress', type: 'address' } ],
          name: 'getContractId',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: '_2keyAmount', type: 'uint256' },
             { name: '_campaignID', type: 'uint256' } ],
          name: 'getUSDStableCoinAmountFrom2keyUnits',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfTokensRequested', type: 'uint256' } ],
          name: 'getMore2KeyTokensForRebalancingV1',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfTokensToReturn', type: 'uint256' } ],
          name: 'returnTokensBackToExchangeV1',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: '_beneficiary', type: 'address' } ],
          name: 'buyTokens',
          outputs:
           [ { name: '', type: 'uint256' }, { name: '', type: 'uint256' } ],
          payable: true,
          stateMutability: 'payable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'amountOfTokens', type: 'uint256' },
             { name: 'tokenAddress', type: 'address' } ],
          name: 'buyTokensWithERC20',
          outputs:
           [ { name: '', type: 'uint256' }, { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [ { name: 'stableCoinAddresses', type: 'address[]' } ],
          name: 'getAvailableAmountToFillReserve',
          outputs: [ { name: '', type: 'uint256[]' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [],
          name: 'releaseAllDAIFromContractToReserve',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfTokensWithdrawn', type: 'uint256' } ],
          name: 'report2KEYWithdrawnFromNetwork',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'amountSrcWei', type: 'uint256' },
             { name: 'srcToken', type: 'address' },
             { name: 'destToken', type: 'address' } ],
          name: 'getKyberExpectedRate',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'stableCoinsAddresses', type: 'address[]' },
             { name: 'amounts', type: 'uint256[]' } ],
          name: 'swapStableCoinsAvailableToFillReserveFor2KEY',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: 'amountToBeHedged', type: 'uint256' },
             { name: 'approvedMinConversionRate', type: 'uint256' } ],
          name: 'startHedging',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'numberOfContractsCurrently', type: 'uint256' },
             { name: 'amountHedged', type: 'uint256' },
             { name: 'stableCoinsReceived', type: 'uint256' },
             { name: 'startIndex', type: 'uint256' },
             { name: 'endIndex', type: 'uint256' } ],
          name: 'calculateHedgedAndReceivedForDefinedChunk',
          outputs:
           [ { name: '', type: 'uint256' }, { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_ethWeiHedgedForThisChunk', type: 'uint256' },
             { name: '_daiReceivedForThisChunk', type: 'uint256' },
             { name: '_ratio', type: 'uint256' },
             { name: '_startIndex', type: 'uint256' },
             { name: '_endIndex', type: 'uint256' } ],
          name: 'reduceHedgedAmountFromContractsAndIncreaseDaiAvailable',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: false,
          inputs:
           [ { name: '_twoKeyUnits', type: 'uint256' },
             { name: '_beneficiary', type: 'address' } ],
          name: 'buyStableCoinWith2key',
          outputs: [],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'numberOfContracts',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractID', type: 'uint256' } ],
          name: 'get2KEY2DAIHedgedRate',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractID', type: 'uint256' } ],
          name: 'getEth2DaiAverageExchangeRatePerContract',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractID', type: 'uint256' } ],
          name: 'getEth2KeyAverageRatePerContract',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'daiWeiAvailableToFill2KEYReserve',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractID', type: 'uint256' } ],
          name: 'daiWeiAvailableToWithdraw',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractID', type: 'uint256' } ],
          name: 'ethWeiAvailableToHedge',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractAddress', type: 'address' } ],
          name: 'getAllStatsForContract',
          outputs:
           [ { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' },
             { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [ { name: '_contractAddress', type: 'address' } ],
          name: 'isCampaignHedgeable',
          outputs: [ { name: '', type: 'bool' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs: [],
          name: 'sellRate2key',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'uniswapRouter', type: 'address' },
             { name: 'input', type: 'uint256' },
             { name: 'path', type: 'address[]' } ],
          name: 'buyRate2Key',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: false,
          inputs: [ { name: 'amountOfDAI', type: 'uint256' } ],
          name: 'withdrawDAIAvailableToFill2KEYReserve',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'nonpayable',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'uniswapRouter', type: 'address' },
             { name: 'amountToReceive', type: 'uint256' },
             { name: 'path', type: 'address[]' } ],
          name: 'uniswapPriceDiscover',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' },
        { constant: true,
          inputs:
           [ { name: 'uniswapRouter', type: 'address' },
             { name: 'amountToSwap', type: 'uint256' },
             { name: 'path', type: 'address[]' } ],
          name: 'uniswapPriceDiscoverForBuyingFromUniswap',
          outputs: [ { name: '', type: 'uint256' } ],
          payable: false,
          stateMutability: 'view',
          type: 'function' } ],
     name: 'TwoKeyUpgradableExchange',
     networks:
      { '1':
         { events: {},
           links:
            { PriceDiscovery: '0x6b1367b4fde82224b25e8162f023bf4a4a8c8094' },
           address: '0x42eac7e4ea4577e0ddb589950eda7804780eb364',
           transactionHash:
            '0xfd6bce1d862b7a3c0340e233f80536dd395a22105c1d73c98f8dbaebe70e05a2',
           implementationAddressLogic: '0x42eac7e4ea4577e0ddb589950eda7804780eb364',
           Proxy: '0x5811e3ce346638eaf61414c91cde7b403c3c4eb5',
           implementationAddressStorage: '0xc29e734d86723f91119be45e6a8f5f189757a19b',
           StorageProxy: '0xb4883d8e93440a7990a6dad349469dd45fb4caac' } } } }